import React, { useState, useEffect } from 'react';

const Chatbot = () => {
    const [message, setMessage] = useState('');
    const [chatHistory, setChatHistory] = useState<{ role: string, content: string }[]>([]);
    const [conversationId, setConversationId] = useState(`chat_${Date.now()}`);

    const handleSendMessage = async () => {
        const newHistory = [...chatHistory, { role: 'user', content: message }];
        setChatHistory(newHistory);
        setMessage('');

        const response = await fetch('/api/ai/chat', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ conversation_id: conversationId, message }),
        });

        const reader = response.body?.getReader();
        const decoder = new TextDecoder();
        let aiResponse = '';

        while (true) {
            const { done, value } = await reader!.read();
            if (done) break;
            const chunk = decoder.decode(value);
            aiResponse += chunk;
            setChatHistory([...newHistory, { role: 'assistant', content: aiResponse }]);
        }
    };

    return (
        <div>
            <h2 className="text-xl font-bold mb-4">AI Chatbot</h2>
            <div className="border rounded-lg p-4 h-96 overflow-y-auto">
                {chatHistory.map((chat, index) => (
                    <div key={index} className={`mb-2 ${chat.role === 'user' ? 'text-right' : 'text-left'}`}>
                        <span className={`inline-block p-2 rounded-lg ${chat.role === 'user' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}>
                            {chat.content}
                        </span>
                    </div>
                ))}
            </div>
            <div className="flex mt-4">
                <input
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                    placeholder="Type your message..."
                />
                <button
                    onClick={handleSendMessage}
                    className="ml-2 bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                    Send
                </button>
            </div>
        </div>
    );
};

export default Chatbot;
